/* eslint-disable */
export default {
  Home: 'Inicio',
  Mobile: 'Móvil',
  Work: 'Trabajo',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
